import TemplateView from '../TemplateView';

export default class AnimatedVisibilityContainer extends TemplateView {
    constructor({
        $containerEl,
        contentComponent,
        containerClass,
        showAnimationClass = "anim-fade-in",
        hideAnimationClass = "anim-fade-out",
        onShowCb = () => {},
        onHideCb = () => {}
    }) {
        super($containerEl)

        this.state = {
            visible: false
        }

        this.callbacks = {
            onShowCb,
            onHideCb,
        }

        this.contentComponent = contentComponent
        this.containerClass = containerClass;

        this.onStatePropertyChanged("visible", visible => {
            if (visible) {
                this.contentComponent.resumeHandlingStateChanges()
                this.$el.atAnimation().showAnimated(showAnimationClass, this.callbacks.onShowCb)
            } else {
                this.contentComponent.stopHandlingStateChanges()
                this.$el.atAnimation().hideAnimated(hideAnimationClass, this.callbacks.onHideCb)
            }
        })
    }

    afterRender() {
        this.$el.hide();
        this.contentComponent.init(this.find(".content"));
    }

    templateHtml() {
        return "<div class='animatedVisibilityContainer <%=containerClass%>'>" +
               "  <div class='content'></div>" +
               "</div>"
    }

    setState(stateChanges) {
        super.setState(stateChanges);
        this.contentComponent.setState(stateChanges);
    }
}


// WEBPACK FOOTER //
// ./web/js/util/AnimatedVisibilityContainer.js